import { render, staticRenderFns } from "./SmyGridItem.vue?vue&type=template&id=106af415&scoped=true&"
import script from "./SmyGridItem.vue?vue&type=script&lang=js&"
export * from "./SmyGridItem.vue?vue&type=script&lang=js&"
import style0 from "./SmyGridItem.vue?vue&type=style&index=0&id=106af415&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106af415",
  null
  
)

export default component.exports